export default __webpack_public_path__ + "static/media/b-img.1a52e4eb.png";